import React, { useState } from "react";
import { EmptyStateNoScopedArgoCDApplications } from "~/areas/infrastructure/components/ArgoCDInstances/components/EmptyStateNoScopedArgoCDApplications";
import { GenerateArgoCDAnnotationsDrawer } from "~/areas/infrastructure/components/ArgoCDInstances/components/GenerateArgoCDAnnotationsDrawer/GenerateArgoCDAnnotationsDrawer";
type NoMappedApplicationsProps = {
    refetch: () => void;
    projectSlug: string;
};
export const NoMappedApplications = (props: NoMappedApplicationsProps) => {
    const { refetch, projectSlug } = props;
    const [showAnnotationsDrawer, setShowAnnotationsDrawer] = useState<boolean>(false);
    return (<>
            <EmptyStateNoScopedArgoCDApplications onGenerateAnnotationsClick={() => {
            setShowAnnotationsDrawer(true);
        }}/>
            <GenerateArgoCDAnnotationsDrawer open={showAnnotationsDrawer} onClose={() => {
            refetch();
            setShowAnnotationsDrawer(false);
        }} initiallySelectedProjectSlug={projectSlug}/>
        </>);
};
